import C from '@/utils/rule/constant'
import BaseCalculator from "./BaseCalculator"

// 1.complete_size的公式存在依赖关系需要注意顺序
class WS extends BaseCalculator {
    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0
    /**
     * 胸臀差
     * @type {number}
     */
    ratio_xt = 0

    body = {
        [C.B_JXTZ_ST] : {
            '平肩' : -1,
            '标准' : 0,
            '溜肩' : 1,
            '斜肩' : 0,
        },
        [C.B_TX_C] : {
            '正常' : 0,
            '挺胸' : 1,
            '广阔' : 0,
            '壮硕' : 0,
        },
        [C.B_TB_B] : {
            '微驼' : 1,
            '正常' : 0,
            '倾斜' : 0,
            '驼背' : 2,
        },
        [C.B_TD_B] : {
            '福态' : 0,
            '富态' : 0,
            '平腹' : 0,
            '将军肚' : 0,
        },
        [C.B_TTT_HT] : {
            '瘦臀' : 0,
            '正常' : 0,
            '丰臀' : 0,
            '饱满' : 0,
        },
    }

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {
        [C.PREFERENCE_FITTED] : {
            [C.C_LW_CL] : function (net, base, plus) {
                return parseFloat(net[C.N_LW_CL]) + 2
            },
            [C.C_XW_CL] : function (net, base, plus) {
                return parseFloat(net[C.N_XW_CL]) + 6
            },
            [C.C_ZY_MW] : function (net, base, plus, complete) {
                return parseFloat(net[C.N_ZYW_MWL]) + 6
            },
            [C.C_TW_HL] : function (net, base, plus) {
                return parseFloat(net[C.N_KTW_HL]) + 6
            },
            [C.C_HYC_BCL] : function (net, base, plus) {
                return (parseFloat(this.height) - 25) / 2 - 8
            },
            [C.C_JK_SW] : function (net, base, plus) {
                return parseFloat(net[C.N_JK_NW])
            },
            [C.C_KXZ_A] : function (net, base, plus) {
                return parseFloat(net[C.N_SBW_UAL]) + 6 + 6
            },
            [C.C_DXC_SSL] : function (net, base, plus) {
                return parseFloat(net[C.N_DXC_SSL]) + 1
            },
            [C.C_DXXK_SSO] : function (net, base, plus) {
                return 0
            },
        },
        [C.PREFERENCE_NORMAL] : {
            [C.C_LW_CL] : function (net, base, plus) {
                return parseFloat(net[C.N_LW_CL]) + 2
            },
            [C.C_XW_CL] : function (net, base, plus) {
                return parseFloat(net[C.N_XW_CL]) + 6
            },
            [C.C_ZY_MW] : function (net, base, plus, complete) {
                return parseFloat(net[C.N_ZYW_MWL]) + 6
            },
            [C.C_TW_HL] : function (net, base, plus) {
                return parseFloat(net[C.N_KTW_HL]) + 6
            },
            [C.C_HYC_BCL] : function (net, base, plus) {
                return (parseFloat(this.height) - 25) / 2 - 8
            },
            [C.C_JK_SW] : function (net, base, plus) {
                return parseFloat(net[C.N_JK_NW])
            },
            [C.C_KXZ_A] : function (net, base, plus) {
                return parseFloat(net[C.N_SBW_UAL]) + 6 + 6
            },
            [C.C_DXC_SSL] : function (net, base, plus) {
                return parseFloat(net[C.N_DXC_SSL]) + 1
            },
            [C.C_DXXK_SSO] : function (net, base, plus) {
                return 0
            },
        },
        [C.PREFERENCE_LOOSE] : {
            [C.C_LW_CL] : function (net, base, plus) {
                return parseFloat(net[C.N_LW_CL]) + 4
            },
            [C.C_XW_CL] : function (net, base, plus) {
                return parseFloat(net[C.N_XW_CL]) + 8
            },
            [C.C_ZY_MW] : function (net, base, plus, complete) {
                return parseFloat(net[C.N_ZYW_MWL]) + 8
            },
            [C.C_TW_HL] : function (net, base, plus) {
                return parseFloat(net[C.N_KTW_HL]) + 8
            },
            [C.C_HYC_BCL] : function (net, base, plus) {
                return (parseFloat(this.height) - 25) / 2 - 8
            },
            [C.C_JK_SW] : function (net, base, plus) {
                return parseFloat(net[C.N_JK_NW])
            },
            [C.C_KXZ_A] : function (net, base, plus) {
                return parseFloat(net[C.N_SBW_UAL]) + 6 + 6
            },
            [C.C_DXC_SSL] : function (net, base, plus) {
                return parseFloat(net[C.N_DXC_SSL]) + 1
            },
            [C.C_DXXK_SSO] : function (net, base, plus) {
                return 0
            },
        }
    }


    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size)
        // 计算胸腰差比和胸臀差比
        this.ratio_xy = (this.net_size[C.N_ZYW_MWL] / this.net_size[C.N_XW_CL] - 1) * 100
        this.ratio_xt = this.net_size[C.N_XW_CL] - this.net_size[C.N_TW_HL]
    }

    /**
     * 穿衣偏好的加放基础值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    base(somatotype, preference) {
        return {}
    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(somatotype, preference) {
        return {}
    }


    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference
        let formulas = this.complete_size[this.preference];

        let result = {}
        for(let key in formulas) {
            let temp = Math.round(formulas[key].apply(this, [this.net_size]) * 10) / 10
            result[key] = isNaN(temp) ? 0 : temp
        }

        return result
    }

    getBodySize() {
        let result = {}
        for(let key in this.body_size) {
            if (key in this.body) result[key] = this.body[key][this.body_size[key]] || 0

        }

        return result
    }
}

export default WS
